import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

export const Route = createFileRoute('/qti-stimulus-embed/')({
  component: QtiEmbedInstructionsPage,
  ssr: false,
});

function QtiEmbedInstructionsPage() {
  const [qtiId, setQtiId] = useState(
    'qti-e9047b80-9a67-4167-8d06-9aad3163b609'
  );

  const baseUrl = window.location.origin;
  const iframeCode = qtiId
    ? `<iframe
  src="${baseUrl}/qti-stimuli-embed/${qtiId}"
  id="qti-embed"
  width="100%"
  height="600px"
  frameborder="0"
></iframe>`
    : '';

  const handleCopyIframeCode = () => {
    navigator.clipboard.writeText(iframeCode);
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">
        QTI Stimulus Embed Instructions
      </h1>

      <div className="flex gap-6">
        {/* Left Sidebar with Controls */}
        <div className="w-1/3 space-y-6">
          <div>
            <h2 className="text-xl font-semibold mb-3">How to Use</h2>
            <ol className="list-decimal pl-6 space-y-2">
              <li>Enter your QTI Stimulus ID in the input field below</li>
              <li>Copy the generated iframe code</li>
              <li>Paste the iframe code into your HTML page</li>
            </ol>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-3">QTI Stimulus ID</h2>
            <div className="flex gap-2">
              <input
                type="text"
                value={qtiId}
                onChange={(e) => setQtiId(e.target.value)}
                placeholder="Enter QTI Item ID"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>

        {/* Main Area with Preview and Code */}
        <div className="w-2/3 space-y-6">
          {qtiId && (
            <div>
              <h2 className="text-xl font-semibold mb-3">
                Generated Embed Code
              </h2>
              <div className="relative">
                <textarea
                  readOnly
                  value={iframeCode}
                  className="w-full h-32 p-3 border border-gray-300 rounded-md font-mono text-sm bg-gray-50"
                />
                <button
                  onClick={handleCopyIframeCode}
                  className="absolute top-2 right-2 px-3 py-1 bg-blue-500 text-white text-sm rounded hover:bg-blue-600"
                >
                  Copy
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
